module.exports = __webpack_public_path__ + "static/img/blo5.9b6db90a.png";